import { redirect } from '@tanstack/react-router';

type GateMe = { user: { emailVerified: boolean }; memberships: readonly unknown[] };

/**
 * An email sign-up that has not confirmed its address and has no shop yet cannot open one: the API answers 403
 * EMAIL_NOT_VERIFIED. Staff, invited users, the CoreUp team and LINE/Google accounts never wait (`user.emailVerified`
 * is already true for LINE, and a shop membership counts as verified).
 */
export function mustVerifyEmail(me: GateMe): boolean {
  return !me.user.emailVerified && me.memberships.length === 0;
}

/** Route guard: send an unverified, shop-less user to the verify-email screen (keeps the chosen type and package). */
export function requireVerifiedEmail(me: GateMe, choice: { industry?: string; plan?: string } = {}): void {
  if (mustVerifyEmail(me))
    throw redirect({ to: '/verify-email', search: { industry: choice.industry, plan: choice.plan } });
}
